import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IDashboardGroup } from '@shared/interfaces/dashboard/dashboard-group';
import { ILoadedMaterial } from '@shared/interfaces/material/loaded-material';
import { ExtractUsedMaterialsPipe } from '@shared/pipes/extract-used-materials.pipe';

@Component({
  selector: 'app-device-material-filter',
  templateUrl: './device-material-filter.component.html',
  styleUrls: ['./device-material-filter.component.scss']
})
export class DeviceMaterialFilterComponent implements OnInit {
  @Input() groups: IDashboardGroup[] = [];

  @Input() filterMaterial: string = '';
  @Output() filterMaterialChange = new EventEmitter<string>(); 

  protected materials: ILoadedMaterial[] = [];

  constructor(
    private extractUsedMaterials: ExtractUsedMaterialsPipe
  ) { }

  ngOnInit(): void {

  }
  
  ngOnChanges(): void {
    this.loadMaterials();
  }

  private loadMaterials(): void {
    this.materials = this.extractUsedMaterials.transform(this.groups);
  }
  
  protected materialTrackBy(index: number, item: ILoadedMaterial): string {
    return item.name;
  }
}
